import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/author/_author/mobility/_mobility')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.mobilities' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
